import { useEffect, useState } from 'react';

function Dashboard({ token, sair }) {

  const [dashboard, setDashboard] = useState({
    colaboradores: 0,
    registrosHoje: 0,
    reconhecimentos: 0,
    ultimosRegistros: []
  });

  useEffect(() => {
    carregarDashboard();
  }, []);

  async function carregarDashboard() {

    try {

      const resposta = await fetch(
        'https://ponto.rhfenix.com.br/api/dashboard',
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (resposta.status === 401) {
        sair();
        return;
      }

      const dados = await resposta.json();

      if (dados.sucesso) {
        setDashboard(dados.dashboard);
      }

    } catch (error) {
      console.error(error);
    }

  }

  return (
    <div className="content">

      <div className="cards">

        <div className="card-dashboard">
          <h3>Colaboradores</h3>
          <strong>{dashboard.colaboradores}</strong>
        </div>

        <div className="card-dashboard">
          <h3>Registros Hoje</h3>
          <strong>{dashboard.registrosHoje}</strong>
        </div>

        <div className="card-dashboard">
          <h3>Faces Cadastradas</h3>
          <strong>{dashboard.reconhecimentos}</strong>
        </div>

        <div className="card-dashboard">
          <h3>Status Sistema</h3>
          <strong>ONLINE</strong>
        </div>

      </div>

      <div className="table-container">

        <div className="page-header">
          <h2>Últimos Registros</h2>
        </div>

        <table>

          <thead>
            <tr>
              <th>Colaborador</th>
              <th>Matrícula</th>
              <th>Tipo</th>
              <th>Confiança</th>
              <th>Data/Hora</th>
            </tr>
          </thead>

          <tbody>

            {dashboard.ultimosRegistros.map((registro) => (

              <tr key={registro.id}>

                <td>{registro.nome}</td>

                <td>{registro.matricula}</td>

                <td>{registro.tipo}</td>

                <td>
                  {Number(registro.confianca).toFixed(2)}
                </td>

                <td>
                  {new Date(
                    registro.created_at
                  ).toLocaleString('pt-BR')}
                </td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

    </div>
  );
}

export default Dashboard;
